import styled from "styled-components";

export const JManDesktop = styled.img`
    position: absolute;
    bottom: 18.9%;
    left: 30%;
    width: 31%;
    height: auto;
`;